import request from '@/utils/request'
import { ResponseData } from './modular'

/**
 * @description: 获取等级列表
 * @param {*}
 * @return {*}
 */
export const getLevelList = () => {
  return request<ResponseData<any>>('/web/getLevels', {
    method: 'GET',
  })
}

/**
 * @description: 支付记录列表
 * @param {*}
 * @return {*}
 */
export const getPayList = (data: any) => {
  return request<ResponseData<any>>('/web/getPayRecords', {
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 获取余额变动记录列表
 * @param {*}
 * @return {*}
 */
export const getBalanceChangeList = (data: any) => {
  return request<ResponseData<any>>('/web/getPlayerBalances', {
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 设置邮箱
 * @param {*}
 * @return {*}
 */
export const setEmail = (data: any) => {
  return request<ResponseData<any>>('/web/updatePlayerEmail', {
    method: 'PUT',
    data,
  })
}

/**
 * @description: 设置手机号
 * @param {*}
 * @return {*}
 */
export const setPhone = (data: any) => {
  return request<ResponseData<any>>('/web/updatePlayerPhone', {
    method: 'PUT',
    data,
  })
}

/**
 * @description: 设置用户真实姓名
 * @param {*}
 * @return {*}
 */
export const setRealName = (data: any) => {
  return request<ResponseData<any>>('/web/updatePlayerRealname', {
    method: 'PUT',
    data,
  })
}

/**
 * @description: 推广汇总
 * @param {*}
 * @return {*}
 */
export const getPromotionSummary = (data: any) => {
  return request<ResponseData<any>>('/web/getAgentData', {
    method: 'GET',
    params: data,
  })
}

/**
 * @description: 修改用户信息
 * @param {*}
 * @return {*}
 */
export const updateUserInfo = (data: any) => {
  return request<ResponseData<any>>('/web/updatePlayerInfo', {
    method: 'PUT',
    data,
  })
}

/**
 * @description: 获取金额转换
 * @param {*}
 * @return {*}
 */
export const getAmountConvert = (data: any) => {
  return request<ResponseData<any>>('/web/currBalance', {
    method: 'GET',
    params: data,
    showLoading: false,
  })
}
